import {
  BusinessChallengesEnum,
  ChallengeUpdateArgsChallengeNumber,
} from '@platform/client/schemas';
import { FormsInputDropdown, FormsMultilineInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageContent } from '../../../application/components/ApplicationPageContent';
import BackgroundImage from '../../../application/images/Margaret-Yebei.svg';
import { challengeOptions } from './consts';
import { BusinessChallenges } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';
import { ChallengeFormBackground } from './ChallengeFormBackground';
import { useParams } from 'wouter';
import { ROUTES } from '../../../routes/consts';
import { navigate } from 'wouter/use-browser-location';

// conditionally remove save exit (or consider jstu new footer?)
// use utils to get backgroudn image

export type ChallengeOneFormValues = {
  firstBusinessChallenge: BusinessChallengesEnum | null;
  firstBusinessChallengeDescription: string | null;
};

export const OrganizationChallengeOne = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const { data: challengeData } = BusinessChallenges.useGetOrganizationBusinessChallenges(
    parseInt(organizationId),
  );
  const defaultValues = {
    firstBusinessChallenge: challengeData?.challenges[0].challenge as BusinessChallengesEnum,
    firstBusinessChallengeDescription: challengeData?.challenges[0].challengeContext,
  };
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ChallengeOneFormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: defaultValues,
  });
  const queryClient = useQueryClient();
  const updateChallengeMutator = BusinessChallenges.useUpdateOrganizationBusinessChallenge({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: BusinessChallenges.getGetOrganizationBusinessChallengesQueryKey(
            parseInt(organizationId),
          ),
        });
        navigate(`/platform${ROUTES.DASHBOARD}`);
      },
    },
  });

  const submit: SubmitHandler<ChallengeOneFormValues> = (data) => {
    if (data.firstBusinessChallenge && data.firstBusinessChallengeDescription) {
      updateChallengeMutator.mutate({
        organizationId: parseInt(organizationId),
        data: {
          challenge_number: challengeData?.challenges[0]
            .challengeNumber as ChallengeUpdateArgsChallengeNumber,
          challenge_value: data.firstBusinessChallenge,
          challenge_context: data.firstBusinessChallengeDescription,
        },
      });
    }
  };

  return (
    <ChallengeFormBackground onSubmit={handleSubmit(submit)} backgroundImage={BackgroundImage}>
      <ApplicationPageContent
        title="Tell us about the challenges you're working through"
        description={
          'Start with your most important challenge. You can add more challenges later. This helps us connect you with the right skills and expertise.'
        }
      >
        <FormsInputDropdown
          control={control}
          name='firstBusinessChallenge'
          rules={{ required: 'Select a challenge your organization needs help with to continue' }}
          label='Select a challenge area'
          placeholder='Select one'
          items={challengeOptions}
          type='default'
          error={errors.firstBusinessChallenge}
          inputDisabled
        />
        <FormsMultilineInput
          control={control}
          label='Tell us more about this challenge'
          placeholder='Enter a description...'
          name={'firstBusinessChallengeDescription'}
          rules={{ maxLength: 500, required: 'Tell us more about this challenge to continue' }}
          formsError={errors.firstBusinessChallengeDescription}
          characterCount={500}
        />
      </ApplicationPageContent>
    </ChallengeFormBackground>
  );
};
